(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[765],{

/***/ 9765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/components/index.ts + 49 modules
var components = __webpack_require__(637);
// EXTERNAL MODULE: ./src/context/index.tsx + 3 modules
var context = __webpack_require__(5215);
// EXTERNAL MODULE: ./src/data/product-details.data.tsx
var product_details_data = __webpack_require__(5717);
// EXTERNAL MODULE: ./src/constants/index.ts + 1 modules
var constants = __webpack_require__(4071);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/data/footer.data.tsx




var dataSocial = [{
  id: "social-1",
  title: "square-facebook",
  icon: "",
  url: constants/* brandLinks.facebook */.kL.facebook
}, {
  id: "social-2",
  title: "Youtube",
  icon: "",
  url: constants/* brandLinks.youtube */.kL.youtube
}, {
  id: "social-3",
  title: "Twitter",
  icon: "𝕏",
  url: constants/* brandLinks.twitter */.kL.twitter
}, {
  id: "social-4",
  title: "Instagram",
  icon: "",
  url: constants/* brandLinks.instagram */.kL.instagram
}];
var dataDisclaimer = [{
  description: {
    mobile: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "A disponibilidade de itens de s\xE9rie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "opcionais e acess\xF3rios pode variar"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "de acordo com a vers\xE3o escolhida."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Verifique o Monte seu Carro."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Imagens meramente ilustrativas."
      })]
    }),
    desktop: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "A disponibilidade de itens de s\xE9rie, opcionais e acess\xF3rios pode variar de acordo com a vers\xE3o escolhida."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Verifique o Monte seu Carro. Imagens meramente ilustrativas."
      })]
    })
  }
}];
// EXTERNAL MODULE: ./src/utils/DataLayer.ts
var DataLayer = __webpack_require__(6450);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/sections/footer-section/footer.module.scss
var footer_module = __webpack_require__(4450);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
;// CONCATENATED MODULE: ./src/sections/footer-section/index.tsx








var Footer = function Footer() {
  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
    className: (footer_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (footer_module_default()).social,
      children: dataSocial.map(function (social) {
        var tracking = function tracking() {
          DataLayer/* default.clickEvent */.Z.clickEvent({
            element: social.title,
            elementCategory: "icone",
            pageSection: "footer",
            pageSubsection: "social"
          });
        };

        return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          target: "_blank",
          href: social.url,
          title: social.title,
          "data-before": social.icon,
          onClick: function onClick() {
            tracking();
          },
          onAuxClick: function onAuxClick() {
            tracking();
          },
          children: social.title
        }, social.id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (footer_module_default()).disclaimer,
      children: [dataDisclaimer.map(function (description) {
        return state.layout.isDesktop ? description.description.desktop : description.description.mobile;
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("legend", {
        className: (footer_module_default()).legalText,
        children: "*Fonte: FENABRAVE"
      })]
    })]
  });
};

/* harmony default export */ var footer_section = (Footer);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./src/assets/gallery.ts
var gallery = __webpack_require__(7333);
// EXTERNAL MODULE: ./src/components/svg-components/index.ts + 10 modules
var svg_components = __webpack_require__(1144);
// EXTERNAL MODULE: ./src/data/menu.data.ts
var menu_data = __webpack_require__(4828);
;// CONCATENATED MODULE: ./src/utils/getRangeOfEntries.ts
var getRangeOfEntries = function getRangeOfEntries() {
  var tIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var array = arguments.length > 1 ? arguments[1] : undefined;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var arrayIndexes = Array.from(array.keys());
  var arrayLength = arrayIndexes.length;
  var halfMax = Math.ceil((max - 1) / 2); // IF THERE IS OVERFLOW

  if (arrayLength > max) {
    if (tIndex + halfMax > arrayLength - 1) {
      var _before = arrayLength - max;

      var _after = 0;
      return {
        after: _after,
        before: _before,
        range: arrayIndexes.slice(max * -1)
      };
    }

    if (tIndex - halfMax < 0) {
      var _before2 = 0;

      var _after2 = arrayLength - 1 - (tIndex + halfMax);

      return {
        after: _after2,
        before: _before2,
        range: arrayIndexes.slice(0, max)
      };
    }

    var after = arrayLength - 1 - (tIndex + halfMax);
    var range = arrayIndexes.slice(tIndex - halfMax, tIndex + halfMax + 1);
    var before = arrayLength - after - range.length;
    return {
      after: after,
      before: before,
      range: range
    };
  } else {
    // THERE IS NO OVERFLOW
    return {
      after: 0,
      before: 0,
      range: arrayIndexes
    };
  }
};

/* harmony default export */ var utils_getRangeOfEntries = (getRangeOfEntries);
// EXTERNAL MODULE: ./src/utils/scssStyles.ts
var scssStyles = __webpack_require__(9688);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js + 2 modules
var AnimatePresence = __webpack_require__(4441);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 82 modules
var motion = __webpack_require__(8553);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(6670);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-swipeable/dist/react-swipeable.umd.js
var react_swipeable_umd = __webpack_require__(6037);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(1911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(2873);
;// CONCATENATED MODULE: ./src/utils/getClientXFromDifferentEvents.ts
var getClientXFromDifferentEvents = function getClientXFromDifferentEvents(event) {
  if (event.type.includes('touch') && typeof (event === null || event === void 0 ? void 0 : event.touches) !== 'undefined') {
    var _touches$0$clientX, _touches$, _changedTouches$;

    var touchX = (_touches$0$clientX = (_touches$ = event.touches[0]) === null || _touches$ === void 0 ? void 0 : _touches$.clientX) !== null && _touches$0$clientX !== void 0 ? _touches$0$clientX : (_changedTouches$ = event.changedTouches[0]) === null || _changedTouches$ === void 0 ? void 0 : _changedTouches$.clientX;
    if (touchX) return touchX;
  }

  return event.clientX;
};

/* harmony default export */ var utils_getClientXFromDifferentEvents = (getClientXFromDifferentEvents);
// EXTERNAL MODULE: ./src/sections/gallery-section/v1/gallery-section.module.scss
var gallery_section_module = __webpack_require__(1007);
var gallery_section_module_default = /*#__PURE__*/__webpack_require__.n(gallery_section_module);
;// CONCATENATED MODULE: ./src/sections/gallery-section/v1/expanded-gallery/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var VisibleImage = (0,es/* observer */.Pi)(function (_ref) {
  var g = _ref.g;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
    src: g.asset.fullPath2x,
    alt: g.title,
    width: 2499,
    height: 1608
  });
});
var expanded_gallery_gallery = gallery/* gallery.filter */.l.filter(function (c) {
  return !c.video;
});
var ExpandedGallery = (0,es/* observer */.Pi)(function () {
  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var _useState = (0,react.useState)(false),
      update = _useState[1];

  var _useState2 = (0,react.useState)(),
      touchLocation = _useState2[0],
      setTouchLocation = _useState2[1];

  var pageSubsection = 'galeria';
  var findIndex = (0,react.useCallback)(function () {
    return expanded_gallery_gallery.findIndex(function (g) {
      return g.id === state.layout.selectedGalleryImage.id;
    });
  }, [state.layout.selectedGalleryImage.id]);
  var updateIndex = (0,react.useCallback)(function (n) {
    var _state$layout$expande;

    dispatch({
      type: 'SET_GALLERY_IMAGE',
      payload: {
        selectedGalleryImage: expanded_gallery_gallery[n]
      }
    });
    (_state$layout$expande = state.layout.expandedSwiperController) === null || _state$layout$expande === void 0 ? void 0 : _state$layout$expande.slideTo(n);
  }, [dispatch, state.layout.expandedSwiperController]);

  var next = function next() {
    var index = findIndex();
    var nIndex = index + 1 > expanded_gallery_gallery.length - 1 ? 0 : index + 1;
    updateIndex(nIndex);
  };

  var previous = function previous() {
    var index = findIndex();
    var nIndex = index - 1 < 0 ? expanded_gallery_gallery.length - 1 : index - 1;
    updateIndex(nIndex);
  };

  var swipeHandlers = (0,react_swipeable_umd.useSwipeable)({
    trackMouse: true,
    onSwipedLeft: function onSwipedLeft() {
      return next();
    },
    onSwipedRight: function onSwipedRight() {
      return previous();
    }
  });

  var ArrowRight = /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ArrowButton */.b4, {
    title: 'Próximo',
    className: (gallery_section_module_default()).arrowRight,
    handleClick: function handleClick() {
      DataLayer/* default.swipeEvent */.Z.swipeEvent({
        element: 'proximo',
        elementCategory: 'imagem',
        pageSection: 'conteudo',
        pageSubsection: pageSubsection
      });
      next();
    }
  });

  var ArrowLeft = /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ArrowButton */.b4, {
    title: 'Anterior',
    previous: true,
    className: (gallery_section_module_default()).arrowLeft,
    handleClick: function handleClick() {
      DataLayer/* default.swipeEvent */.Z.swipeEvent({
        element: 'anterior',
        elementCategory: 'imagem',
        pageSection: 'conteudo',
        pageSubsection: pageSubsection
      });
      previous();
    }
  });

  (0,react.useEffect)(function () {
    update(function (v) {
      return !v;
    });
  }, []);
  (0,react.useEffect)(function () {
    var _state$layout$expande2;

    if (state.layout.galleryExpanded && ((_state$layout$expande2 = state.layout.expandedSwiperController) === null || _state$layout$expande2 === void 0 ? void 0 : _state$layout$expande2.destroyed) !== true) {
      var _state$layout$expande3;

      (_state$layout$expande3 = state.layout.expandedSwiperController) === null || _state$layout$expande3 === void 0 ? void 0 : _state$layout$expande3.slideTo(findIndex());
    }
  }, [findIndex, state.layout.expandedSwiperController, state.layout.galleryExpanded]);
  (0,react.useEffect)(function () {
    var _document$body;

    var escapeClose = function escapeClose(ev) {
      if (ev.key === 'Escape') {
        dispatch({
          type: 'SET_GALLERY_EXPANDED',
          payload: {
            galleryExpanded: false
          }
        });
      }
    };

    (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.addEventListener('keydown', function (e) {
      return escapeClose(e);
    });
    return function () {
      var _document$body2;

      (_document$body2 = document.body) === null || _document$body2 === void 0 ? void 0 : _document$body2.removeEventListener('keydown', function (e) {
        return escapeClose(e);
      });
    };
  }, [dispatch]);
  var bulletProps = utils_getRangeOfEntries(findIndex(), expanded_gallery_gallery);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
    className: (gallery_section_module_default()).expandedGallery,
    initial: {
      opacity: 0.2,
      y: 100
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0.2,
      y: 100
    },
    transition: {
      duration: 0.3
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.t, {
      observeParents: true,
      observer: true,
      parallax: true,
      spaceBetween: 50,
      slidesPerView: 1,
      onSwiper: function onSwiper(e) {
        return dispatch({
          type: 'SET_EXPANDED_CONTROLLER',
          payload: {
            expandedSwiperController: e
          }
        });
      },
      controller: state.layout.expandedSwiperController ? {
        control: state.layout.expandedSwiperController
      } : undefined,
      onSlideChange: function onSlideChange(e) {
        var index = e.activeIndex;
        dispatch({
          type: 'SET_GALLERY_IMAGE',
          payload: {
            selectedGalleryImage: expanded_gallery_gallery[index]
          }
        });
      },
      onTouchStart: function onTouchStart(_, event) {
        var clientX = utils_getClientXFromDifferentEvents(event);
        setTouchLocation(clientX);
      },
      onTouchEnd: function onTouchEnd(_, event) {
        var clientX = utils_getClientXFromDifferentEvents(event);
        DataLayer/* default.swipeEvent */.Z.swipeEvent({
          element: (touchLocation !== null && touchLocation !== void 0 ? touchLocation : 0) > clientX ? 'proximo' : 'anterior',
          elementCategory: 'imagem',
          pageSection: 'conteudo',
          pageSubsection: pageSubsection
        });
      },
      children: expanded_gallery_gallery.map(function (g) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
          className: (gallery_section_module_default()).expandedSlide,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(VisibleImage, {
            g: g
          })
        }, "expanded-gallery-".concat(g.id));
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Conditional */.hW, {
      notOn: "desktop",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", _objectSpread(_objectSpread({
        className: (gallery_section_module_default()).controls
      }, swipeHandlers), {}, {
        children: [ArrowLeft, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (gallery_section_module_default()).bullets,
          children: [!!bulletProps.before && Array.from(Array(bulletProps.before).keys()).slice(0, 2).map(function (_, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: (0,scssStyles/* default */.Z)([(gallery_section_module_default()).bullet, i == 1 || bulletProps.before === 1 ? 'mediumBullet' : 'smallerBullet']),
              onClick: function onClick() {
                DataLayer/* default.clickEvent */.Z.clickEvent({
                  element: "foto-".concat(findIndex() - 2),
                  elementCategory: 'icone',
                  pageSection: 'conteudo',
                  pageSubsection: pageSubsection
                });
                updateIndex(findIndex() - 2);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
            }, "smaller-bullet-galleryExpanded-before-".concat(i));
          }), expanded_gallery_gallery.map(function (c, index) {
            if (bulletProps.range.indexOf(index) === -1) return null;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              title: c.title,
              className: (0,scssStyles/* default */.Z)([(gallery_section_module_default()).bullet, state.layout.selectedGalleryImage.id === c.id ? (gallery_section_module_default()).active : '']),
              onClick: function onClick() {
                var _state$layout$expande4;

                DataLayer/* default.clickEvent */.Z.clickEvent({
                  element: "foto-".concat(index + 1),
                  elementCategory: 'imagem',
                  pageSection: 'conteudo',
                  pageSubsection: pageSubsection
                });
                dispatch({
                  type: 'SET_GALLERY_IMAGE',
                  payload: {
                    selectedGalleryImage: c
                  }
                });
                (_state$layout$expande4 = state.layout.expandedSwiperController) === null || _state$layout$expande4 === void 0 ? void 0 : _state$layout$expande4.slideTo(expanded_gallery_gallery.findIndex(function (x) {
                  return x.id === c.id;
                }));
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
            }, "bullet-".concat(c.id));
          }), !!bulletProps.after && Array.from(Array(bulletProps.after).keys()).slice(0, 2).map(function (_, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: (0,scssStyles/* default */.Z)([(gallery_section_module_default()).bullet, i == 0 || bulletProps.after === 1 ? 'mediumBullet' : 'smallerBullet']),
              onClick: function onClick() {
                DataLayer/* default.clickEvent */.Z.clickEvent({
                  element: "foto-".concat(findIndex() + 2),
                  elementCategory: 'icone',
                  pageSection: 'conteudo',
                  pageSubsection: pageSubsection
                });
                updateIndex(findIndex() + 2);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
            }, "smaller-bullet-galleryExpanded-after-".concat(i));
          })]
        }), ArrowRight]
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      title: "Fechar",
      className: (gallery_section_module_default()).closeButton,
      onClick: function onClick() {
        DataLayer/* default.clickEvent */.Z.clickEvent({
          element: 'fechar',
          elementCategory: 'icone',
          pageSection: 'conteudo',
          pageSubsection: pageSubsection
        });
        dispatch({
          type: 'SET_GALLERY_EXPANDED',
          payload: {
            galleryExpanded: !state.layout.galleryExpanded
          }
        });
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(svg_components/* Close */.x8, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Conditional */.hW, {
      notOn: "mobile",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (gallery_section_module_default()).controlsDesktop,
        children: [ArrowLeft, ArrowRight]
      })
    })]
  });
});
/* harmony default export */ var expanded_gallery = (ExpandedGallery);
;// CONCATENATED MODULE: ./src/sections/gallery-section/v1/index.tsx


function v1_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function v1_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? v1_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : v1_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















swiper_esm/* default.use */.ZP.use([swiper_esm/* A11y */.s5, swiper_esm/* Keyboard */.N1, swiper_esm/* Thumbs */.o3]);
var reference = (0,menu_data/* dataMenuLabels */.SC)().find(function (c) {
  return c.slug === "galeria";
});
var GalleryV1 = (0,es/* observer */.Pi)(function () {
  var _state$layout$selecte2;

  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var _useState = (0,react.useState)(),
      controller = _useState[0],
      setController = _useState[1];

  var pageSubsection = "galeria";

  var findIndex = function findIndex() {
    return gallery/* gallery.findIndex */.l.findIndex(function (g) {
      var _state$layout$selecte;

      return g.id === ((_state$layout$selecte = state.layout.selectedGalleryImage) === null || _state$layout$selecte === void 0 ? void 0 : _state$layout$selecte.id);
    });
  };

  var updateIndex = (0,react.useCallback)(function (n) {
    dispatch({
      type: "SET_GALLERY_IMAGE",
      payload: {
        selectedGalleryImage: gallery/* gallery */.l[n]
      }
    });

    if (controller && typeof n === "number") {
      controller === null || controller === void 0 ? void 0 : controller.slideTo(n);
    }
  }, [controller, dispatch]);

  var next = function next() {
    var index = findIndex();
    var nIndex = index + 1 > gallery/* gallery.length */.l.length - 1 ? 0 : index + 1;
    updateIndex(nIndex);
  };

  var previous = function previous() {
    var index = findIndex();
    var nIndex = index - 1 < 0 ? gallery/* gallery.length */.l.length - 1 : index - 1;
    updateIndex(nIndex);
  };

  var swipeHandlers = (0,react_swipeable_umd.useSwipeable)({
    trackMouse: true,
    onSwipedLeft: function onSwipedLeft() {
      DataLayer/* default.swipeEvent */.Z.swipeEvent({
        element: "anterior",
        elementCategory: "imagem",
        pageSection: "conteudo",
        pageSubsection: pageSubsection
      });
      next();
    },
    onSwipedRight: function onSwipedRight() {
      DataLayer/* default.swipeEvent */.Z.swipeEvent({
        element: "proximo",
        elementCategory: "imagem",
        pageSection: "conteudo",
        pageSubsection: pageSubsection
      });
      previous();
    }
  });
  var bulletProps = utils_getRangeOfEntries(findIndex(), gallery/* gallery */.l);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SectionElement */.pK, {
      noPadding: true,
      id: "Gallery",
      className: (gallery_section_module_default()).container,
      navReference: reference,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (gallery_section_module_default()).title,
        children: state.layout.isDesktop ? /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
          children: ["A sua ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Fiat Strada"
          }), " por todos os \xE2ngulos"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
          children: ["A sua ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Fiat Strada"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " por todos os \xE2ngulos"]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (gallery_section_module_default()).galleryContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (gallery_section_module_default()).aligner,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (gallery_section_module_default()).mainImage,
            children: [!((_state$layout$selecte2 = state.layout.selectedGalleryImage) !== null && _state$layout$selecte2 !== void 0 && _state$layout$selecte2.video) && /*#__PURE__*/(0,jsx_runtime.jsx)(components/* IconButton */.hU, {
              className: (gallery_section_module_default()).expandIcon,
              title: "Expandir imagem",
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(svg_components/* Magnifying */.Ip, {})
              }),
              handleClick: function handleClick() {
                DataLayer/* default.clickEvent */.Z.clickEvent({
                  element: "amplia-foto-".concat(gallery/* gallery.findIndex */.l.findIndex(function (c) {
                    return c.id === state.layout.selectedGalleryImage.id;
                  }) + 1),
                  elementCategory: "icone",
                  pageSection: "conteudo",
                  pageSubsection: pageSubsection
                });
                dispatch({
                  type: "SET_GALLERY_EXPANDED",
                  payload: {
                    galleryExpanded: !state.layout.galleryExpanded
                  }
                });
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
              children: gallery/* gallery.map */.l.map(function (g) {
                var _state$layout$selecte3;

                var isMobile = !state.layout.isDesktop;
                if (((_state$layout$selecte3 = state.layout.selectedGalleryImage) === null || _state$layout$selecte3 === void 0 ? void 0 : _state$layout$selecte3.id) !== g.id) return null;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, v1_objectSpread(v1_objectSpread({}, swipeHandlers), {}, {
                  initial: {
                    opacity: 0,
                    y: isMobile ? -100 : 0,
                    x: !isMobile ? 100 : 0
                  },
                  animate: {
                    opacity: 1,
                    y: 0,
                    x: 0,
                    scale: 1
                  },
                  exit: {
                    opacity: 0,
                    y: isMobile ? 100 : 0,
                    x: !isMobile ? 100 : 0
                  },
                  transition: {
                    duration: 0.2
                  },
                  children: !!g.video && !!g.video.desktop ? /*#__PURE__*/(0,jsx_runtime.jsx)(components/* VimeoEmbed */.it, {
                    id: g.video.desktop,
                    className: (gallery_section_module_default()).videoHolder,
                    title: g.title
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    alt: g.alt,
                    title: g.title,
                    src: g.asset.fullPath3x,
                    layout: "fill",
                    objectPosition: "center",
                    objectFit: state.layout.isDesktop ? "cover" : "fill"
                  })
                }), "main-gallery-".concat(g.id));
              })
            })]
          }), state.layout.isDesktop ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (gallery_section_module_default()).thumbsDesktop,
            children: gallery/* galleryThumbs.map */.N.map(function (p, index) {
              var _state$layout$selecte4;

              return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: function onClick() {
                  DataLayer/* default.clickEvent */.Z.clickEvent({
                    element: "foto-".concat(index + 1),
                    elementCategory: "icone",
                    pageSection: "conteudo",
                    pageSubsection: pageSubsection
                  });
                  dispatch({
                    type: "SET_GALLERY_IMAGE",
                    payload: {
                      selectedGalleryImage: p
                    }
                  });
                },
                className: (0,scssStyles/* default */.Z)([((_state$layout$selecte4 = state.layout.selectedGalleryImage) === null || _state$layout$selecte4 === void 0 ? void 0 : _state$layout$selecte4.id) === p.id ? (gallery_section_module_default()).active : ""]),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: p.thumb,
                  alt: p.alt,
                  title: p.title,
                  layout: "responsive",
                  objectFit: "contain",
                  width: 224,
                  height: 152
                })
              }, "galleryThumb-".concat(p.id));
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (gallery_section_module_default()).thumbs,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.t, {
                observer: true,
                observeParents: true,
                parallax: true,
                spaceBetween: 10,
                slidesPerView: 2.5,
                onSwiper: function onSwiper(e) {
                  return setController(e);
                },
                controller: controller ? {
                  control: controller
                } : undefined,
                className: (gallery_section_module_default()).swiperMobile,
                children: gallery/* galleryThumbs.map */.N.map(function (p, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                    className: (gallery_section_module_default()).swiperSlide,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                      onClick: function onClick() {
                        DataLayer/* default.clickEvent */.Z.clickEvent({
                          element: "foto-".concat(index + 1),
                          elementCategory: "imagem",
                          pageSection: "conteudo",
                          pageSubsection: pageSubsection
                        });
                        updateIndex(index);
                      },
                      className: state.layout.selectedGalleryImage.id === p.id ? (gallery_section_module_default()).active : "",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (gallery_section_module_default()).thumbContainer,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                          src: p.thumb,
                          alt: p.alt,
                          title: p.title,
                          layout: "responsive",
                          objectFit: "contain",
                          width: 128,
                          height: 87
                        })
                      })
                    })
                  }, "gallery-thumb-".concat(p.id));
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (gallery_section_module_default()).controls,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ArrowButton */.b4, {
                title: "Anterior",
                previous: true,
                handleClick: function handleClick() {
                  previous();
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (gallery_section_module_default()).bullets,
                children: [!!bulletProps.before && Array.from(Array(bulletProps.before).keys()).slice(0, 2).map(function (_, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    className: (0,scssStyles/* default */.Z)([(gallery_section_module_default()).bullet, i == 1 || bulletProps.before === 1 ? "mediumBullet" : "smallerBullet"]),
                    onClick: function onClick() {
                      DataLayer/* default.clickEvent */.Z.clickEvent({
                        element: "foto-".concat(findIndex() - 2),
                        elementCategory: "icone",
                        pageSection: "conteudo",
                        pageSubsection: pageSubsection
                      });
                      updateIndex(findIndex() - 2);
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
                  }, "smaller-bullet-gallery-before-".concat(i));
                }), gallery/* gallery.map */.l.map(function (c, index) {
                  var _state$layout$selecte5;

                  if (bulletProps.range.indexOf(index) === -1) return null;
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    title: c.title,
                    className: (0,scssStyles/* default */.Z)([(gallery_section_module_default()).bullet, ((_state$layout$selecte5 = state.layout.selectedGalleryImage) === null || _state$layout$selecte5 === void 0 ? void 0 : _state$layout$selecte5.id) === c.id ? (gallery_section_module_default()).active : ""]),
                    onClick: function onClick() {
                      DataLayer/* default.clickEvent */.Z.clickEvent({
                        element: "foto-".concat(index + 1),
                        elementCategory: "icone",
                        pageSection: "conteudo",
                        pageSubsection: pageSubsection
                      });
                      dispatch({
                        type: "SET_GALLERY_IMAGE",
                        payload: {
                          selectedGalleryImage: c
                        }
                      });
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
                  }, "bullet-".concat(c.id));
                }), !!bulletProps.after && Array.from(Array(bulletProps.after).keys()).slice(0, 2).map(function (_, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    className: (0,scssStyles/* default */.Z)([(gallery_section_module_default()).bullet, i == 0 || bulletProps.after === 1 ? "mediumBullet" : "smallerBullet"]),
                    onClick: function onClick() {
                      DataLayer/* default.clickEvent */.Z.clickEvent({
                        element: "foto-".concat(findIndex() + 2),
                        elementCategory: "icone",
                        pageSection: "conteudo",
                        pageSubsection: pageSubsection
                      });
                      updateIndex(findIndex() + 2);
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
                  }, "smaller-bullet-gallery-after-".concat(i));
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ArrowButton */.b4, {
                title: "Próximo",
                handleClick: function handleClick() {
                  DataLayer/* default.clickEvent */.Z.clickEvent({
                    element: "proximo",
                    elementCategory: "icone",
                    pageSection: "conteudo",
                    pageSubsection: pageSubsection
                  });
                  next();
                }
              })]
            })]
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: state.layout.galleryExpanded && /*#__PURE__*/(0,jsx_runtime.jsx)(expanded_gallery, {})
    })]
  });
});
;// CONCATENATED MODULE: ./src/sections/gallery-section/index.tsx

// EXTERNAL MODULE: ./src/utils/imagePrefixes.ts
var imagePrefixes = __webpack_require__(6551);
;// CONCATENATED MODULE: ./src/data/hero.data.tsx



var STORIES_PREFIX = "Stories/";
var HERO_DESKTOP_PREFIX = "HeroDesktop/";
var THUMB_PREFIX = "".concat(HERO_DESKTOP_PREFIX, "thumbs/");
var BACKGROUNDS_PREFIX = "".concat(HERO_DESKTOP_PREFIX, "backgrounds/");
var heroFirstBackground = (0,imagePrefixes/* includeResponsive */.X9)("".concat(BACKGROUNDS_PREFIX, "fiat-strada-2024"), "webp");
var heroFirstAltTag = "Nova Fiat Strada";
var heroFirstTitleTag = "Nova Fiat Strada";
var storiesFirstBackground = (0,imagePrefixes/* includeResponsive */.X9)("".concat(STORIES_PREFIX, "fiat-strada-2024"), "webp");
var storiesFirstAltTag = "Nova Fiat Strada";
var storiesFirstTitleTag = "Nova Fiat Strada";
var dataHero = [{
  id: "1",
  title: "Nova versão Ultra",
  titleStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Nova vers\xE3o Ultra"
  }),
  description: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "A nova vers\xE3o Ultra chega com seu visual \xFAnico, robusto e urbano para enfrentar seus desafios di\xE1rios."
  }),
  descriptionStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "A nova vers\xE3o Ultra chega com seu visual \xFAnico, robusto e urbano para enfrentar seus desafios di\xE1rios."
  }),
  altTag: "Nova versão Ultra",
  titleTag: "Nova versão Ultra",
  cardTitle: "Nova versão Ultra",
  cardSrc: (0,imagePrefixes/* includeResponsive */.X9)("".concat(THUMB_PREFIX, "fiat-strada-nova-versao-ultra-thumb"), "webp"),
  backgrounds: [(0,imagePrefixes/* includeResponsive */.X9)("".concat(BACKGROUNDS_PREFIX, "fiat-strada-nova-versao-ultra"), "webp"), (0,imagePrefixes/* includeResponsive */.X9)("".concat(STORIES_PREFIX, "fiat-strada-nova-versao-ultra"), "webp")]
}, {
  id: "2",
  title: "Novo design",
  titleStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Novo design"
  }),
  description: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "A uni\xE3o perfeita entre versatilidade e design. Aprecie detalhe como volante com regulagem de altura, bancos em tecido com Fiat Flag e mais."
  }),
  descriptionStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "A uni\xE3o perfeita entre versatilidade e design. Aprecie detalhe como volante com regulagem de altura, bancos em tecido com Fiat Flag e mais."
  }),
  altTag: "Novo design",
  titleTag: "Novo design",
  cardTitle: "Novo design",
  cardSrc: (0,imagePrefixes/* includeResponsive */.X9)("".concat(THUMB_PREFIX, "fiat-strada-novo-design-unico-thumb"), "webp"),
  backgrounds: [(0,imagePrefixes/* includeResponsive */.X9)("".concat(BACKGROUNDS_PREFIX, "fiat-strada-novo-design-unico"), "webp"), (0,imagePrefixes/* includeResponsive */.X9)("".concat(STORIES_PREFIX, "fiat-strada-novo-design-unico"), "webp")]
}, {
  id: "3",
  title: "Motor Turbo 200 Flex",
  titleStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Motor Turbo 200 Flex"
  }),
  description: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "A primeira picape compacta de turbo do mundo. A Strada que voc\xEA j\xE1 conhece ficou ainda melhor com novo Motor Turbo Flex T200 com economia como voc\xEA nunca viu."
  }),
  descriptionStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "A primeira picape compacta de turbo do mundo. A Strada que voc\xEA j\xE1 conhece ficou ainda melhor com novo Motor Turbo Flex T200 com economia como voc\xEA nunca viu."
  }),
  altTag: "Motor Turbo 200 Flex",
  titleTag: "Motor Turbo 200 Flex",
  cardTitle: "Motor Turbo 200 Flex",
  cardSrc: (0,imagePrefixes/* includeResponsive */.X9)("".concat(THUMB_PREFIX, "fiat-strada-novo-motor-turbo-200-thumb"), "webp"),
  backgrounds: [(0,imagePrefixes/* includeResponsive */.X9)("".concat(BACKGROUNDS_PREFIX, "fiat-strada-novo-motor-turbo-200"), "webp"), (0,imagePrefixes/* includeResponsive */.X9)("".concat(STORIES_PREFIX, "fiat-strada-novo-motor-turbo-200"), "webp")]
}, {
  id: "4",
  title: "A/C Digital Automático",
  titleStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "A/C Digital Autom\xE1tico"
  }),
  description: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Mais conforto e tecnologia em qualquer momento. Controle o clima com bot\xF5es de f\xE1cil acesso com ar-condicionado digital da sua Fiat Strada."
  }),
  descriptionStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Mais conforto e tecnologia em qualquer momento. Controle o clima com bot\xF5es de f\xE1cil acesso com ar-condicionado digital da sua Fiat Strada."
  }),
  altTag: "A/C Digital Automático",
  titleTag: "A/C Digital Automático",
  cardTitle: "A/C Digital Automático",
  cardSrc: (0,imagePrefixes/* includeResponsive */.X9)("".concat(THUMB_PREFIX, "fiat-strada-ar-condicionado-digital-thumb"), "webp"),
  backgrounds: [(0,imagePrefixes/* includeResponsive */.X9)("".concat(BACKGROUNDS_PREFIX, "fiat-strada-ar-condicionado-digital"), "webp"), (0,imagePrefixes/* includeResponsive */.X9)("".concat(STORIES_PREFIX, "fiat-strada-ar-condicionado-digital"), "webp")]
}, {
  id: "5",
  title: "Carregamento sem fio",
  titleStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Carregamento sem fio"
  }),
  description: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Praticidade em qualquer momento. Carregue seu celular sem o uso de fios atrav\xE9s da tecnologia Wireless Charger e mantenha-se sempre conectado."
  }),
  descriptionStories: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "Praticidade em qualquer momento. Carregue seu celular sem o uso de fios atrav\xE9s da tecnologia Wireless Charger e mantenha-se sempre conectado."
  }),
  altTag: "Carregamento sem fio",
  titleTag: "Carregamento sem fio",
  cardTitle: "Carregamento sem fio",
  cardSrc: (0,imagePrefixes/* includeResponsive */.X9)("".concat(THUMB_PREFIX, "fiat-strada-carregamento-sem-fio-thumb"), "webp"),
  backgrounds: [(0,imagePrefixes/* includeResponsive */.X9)("".concat(BACKGROUNDS_PREFIX, "fiat-strada-carregamento-sem-fio"), "webp"), (0,imagePrefixes/* includeResponsive */.X9)("".concat(STORIES_PREFIX, "fiat-strada-carregamento-sem-fio"), "webp")]
}];
// EXTERNAL MODULE: ./src/sections/hero-section/HeroDesktop.module.scss
var HeroDesktop_module = __webpack_require__(6146);
var HeroDesktop_module_default = /*#__PURE__*/__webpack_require__.n(HeroDesktop_module);
;// CONCATENATED MODULE: ./src/sections/hero-section/index.tsx


function hero_section_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function hero_section_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? hero_section_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : hero_section_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var HeroDesktop = function HeroDesktop() {
  var previous = react.useRef(null);
  var next = react.useRef(null);
  var items = [];
  var reference = (0,menu_data/* dataMenuLabels */.SC)().find(function (c) {
    return c.slug === "";
  });
  items.push({
    body: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (0,scssStyles/* default */.Z)([(HeroDesktop_module_default()).slides, (HeroDesktop_module_default()).mainSlide]),
      title: "Nova fiat Strada com motor turbo",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (HeroDesktop_module_default()).svg1,
        children: " "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (HeroDesktop_module_default()).svg2,
        children: " "
      })]
    }),
    background: {
      src: heroFirstBackground,
      alt: heroFirstAltTag
    }
  });
  dataHero.map(function (item) {
    return items.push({
      body: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (0,scssStyles/* default */.Z)([(HeroDesktop_module_default()).slides]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (HeroDesktop_module_default()).fullBgGradient,
          title: item.titleTag
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (HeroDesktop_module_default()).content,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (HeroDesktop_module_default()).descriptionContent,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (HeroDesktop_module_default()).descriptionLayoutTwo,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: (HeroDesktop_module_default()).tltBottom,
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (HeroDesktop_module_default()).line
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: item.description
              })]
            })
          })
        })]
      }),
      background: {
        src: item.backgrounds[0],
        alt: item.altTag
      }
    });
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SectionElement */.pK, {
    noPadding: true,
    id: "desktopDisplay",
    className: (HeroDesktop_module_default()).container,
    navReference: reference,
    handleKeyDown: function handleKeyDown(e, isVisible) {
      if (isVisible) {
        if (e.key === "ArrowLeft") {
          (previous === null || previous === void 0 ? void 0 : previous.current) && (previous === null || previous === void 0 ? void 0 : previous.current());
        } else if (e.key === "ArrowRight") {
          (next === null || next === void 0 ? void 0 : next.current) && (next === null || next === void 0 ? void 0 : next.current());
        }
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Display */.sS, {
      previousEvent: function previousEvent(e) {
        previous.current = e;
      },
      nextEvent: function nextEvent(e) {
        next.current = e;
      },
      items: items
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (HeroDesktop_module_default()).scrollImage,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Arraste para saber mais"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Chevron */.Tt, {
        direction: "down",
        color: "white",
        thicker: true
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Cards */.oy, {
      items: dataHero.map(function (d) {
        return hero_section_objectSpread(hero_section_objectSpread({}, d), {}, {
          src: d.cardSrc,
          title: d.cardTitle,
          alt: d.altTag
        });
      })
    })]
  });
};
// EXTERNAL MODULE: ./src/sections/product-details-section/product-details-section.module.scss
var product_details_section_module = __webpack_require__(3559);
var product_details_section_module_default = /*#__PURE__*/__webpack_require__.n(product_details_section_module);
// EXTERNAL MODULE: ./src/sections/product-details-section/product-details-tabs-component/product-details-tabs.module.scss
var product_details_tabs_module = __webpack_require__(297);
var product_details_tabs_module_default = /*#__PURE__*/__webpack_require__.n(product_details_tabs_module);
;// CONCATENATED MODULE: ./src/sections/product-details-section/product-details-tabs-component/index.tsx









var Tab = (0,es/* observer */.Pi)(function (_ref) {
  var tab = _ref.tab;

  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var pageSubsection = "tudo-sobre";

  var handleSelectedDetailTab = function handleSelectedDetailTab(tab) {
    dispatch({
      type: "SET_CURRENTLY_VISIBLE_NAV",
      payload: {
        tab: tab
      }
    });
    dispatch({
      type: "SET_DETAIL_TAB",
      payload: {
        selectedDetailTab: tab
      }
    });
  };

  (0,react.useEffect)(function () {
    if (state.layout.selectedDetailTab === "") {
      dispatch({
        type: "SET_DETAIL_TAB",
        payload: {
          selectedDetailTab: product_details_data/* default.0 */.ZP[0]
        }
      });
      dispatch({
        type: "SWIPE_TO_TAB",
        payload: {
          tab: product_details_data/* default.0 */.ZP[0]
        }
      });
    }
  }, [dispatch, state.layout.selectedDetailTab]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    className: (0,scssStyles/* default */.Z)([(product_details_tabs_module_default()).tab, state.layout.selectedDetailTab === tab.id ? (product_details_tabs_module_default()).active : ""]),
    href: "/strada/".concat(menu_data/* PRODUCT_DETAILS_PREFIX */.gQ, "/").concat(tab.slug),
    onClick: function onClick(e) {
      DataLayer/* default.clickEvent */.Z.clickEvent({
        element: tab.title,
        elementCategory: "botao",
        pageSection: "conteudo",
        pageSubsection: pageSubsection
      });
      dispatch({
        type: "SET_DETAIL_TAB",
        payload: {
          selectedDetailTab: tab
        }
      });
      dispatch({
        type: "SWIPE_TO_TAB",
        payload: {
          tab: tab
        }
      });
      handleSelectedDetailTab(tab);
      e.preventDefault();
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (product_details_tabs_module_default()).content,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: tab.title
      })
    })
  });
});

var Tabs = function Tabs(_ref2) {
  var flexDirection = _ref2.flexDirection;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (product_details_tabs_module_default()).container,
    style: {
      flexDirection: flexDirection ? flexDirection : "row"
    },
    children: product_details_data/* default.map */.ZP.map(function (tab) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Tab, {
        tab: tab
      }, "tab--".concat(tab.id));
    })
  });
};

/* harmony default export */ var product_details_tabs_component = (Tabs);
// EXTERNAL MODULE: ./src/sections/product-details-section/product-details-swiper-component/swiper-product-details-desktop.module.scss
var swiper_product_details_desktop_module = __webpack_require__(603);
var swiper_product_details_desktop_module_default = /*#__PURE__*/__webpack_require__.n(swiper_product_details_desktop_module);
;// CONCATENATED MODULE: ./src/sections/product-details-section/product-details-swiper-component/swiper-product-details-desktop.component.tsx



function swiper_product_details_desktop_component_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function swiper_product_details_desktop_component_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? swiper_product_details_desktop_component_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : swiper_product_details_desktop_component_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















swiper_esm/* default.use */.ZP.use([swiper_esm/* A11y */.s5, swiper_esm/* Keyboard */.N1, swiper_esm/* Thumbs */.o3]);
var pageSection = 'tudo-sobre';
var Slide = (0,es/* observer */.Pi)(function (_ref) {
  var _slide$vimeoId, _slide$labelBtn;

  var slide = _ref.slide,
      productDetailsVersion = _ref.productDetailsVersion;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (swiper_product_details_desktop_module_default()).slideContainer,
    children: [(_slide$vimeoId = slide.vimeoId) !== null && _slide$vimeoId !== void 0 && _slide$vimeoId.desktop ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (swiper_product_details_desktop_module_default()).videoWrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* VimeoEmbed */.it, {
        id: slide.vimeoId.desktop,
        title: slide.title
      })
    }) : productDetailsVersion === 2 ? null : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (swiper_product_details_desktop_module_default()).slideImageContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: slide.image.fullPath2x,
        alt: slide.title,
        title: slide.title,
        width: 2196,
        height: 1413
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (swiper_product_details_desktop_module_default()).slideDetails,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: slide.parentTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: slide.title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (swiper_product_details_desktop_module_default()).slideDescription,
        children: [slide.descriptionDesktop, !!slide.fileUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* CTAButton */.m3, {
            href: slide.fileUrl,
            className: (swiper_product_details_desktop_module_default()).ctaButton,
            text: (_slide$labelBtn = slide.labelBtn) !== null && _slide$labelBtn !== void 0 ? _slide$labelBtn : '',
            width: '25%',
            title: slide.title,
            backgroundColor: '#fff',
            color: '#000',
            excludeArrow: slide.breakTitle //download={item.download}
            //iconCode={item.iconCode}

          }, "menu-cta-".concat(slide.id))
        })]
      })]
    })]
  });
});
var SwipersDesktop = (0,es/* observer */.Pi)(function (_ref2) {
  var _state$layout$product3, _state$layout$product4, _state$layout$product6, _state$layout$product7;

  var productDetailsVersion = _ref2.productDetailsVersion,
      setReference = _ref2.setReference;

  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var _useState = (0,react.useState)(false),
      rerender = _useState[1];

  var _useState2 = (0,react.useState)(),
      touchLocation = _useState2[0],
      setTouchLocation = _useState2[1];

  var nextSlide = !state.layout.productDetailsSwiperController ? undefined : product_details_data/* allSlides */.eW[state.layout.productDetailsSwiperController.activeIndex + 1];
  var previousSlide = !state.layout.productDetailsSwiperController ? undefined : product_details_data/* allSlides */.eW[state.layout.productDetailsSwiperController.activeIndex - 1];

  var handleSwiperChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(tab) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch({
                type: 'SET_CURRENTLY_VISIBLE_NAV',
                payload: {
                  tab: tab
                }
              });

            case 2:
              _context.next = 4;
              return dispatch({
                type: 'SET_DETAIL_TAB',
                payload: {
                  selectedDetailTab: tab
                }
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSwiperChange(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (swiper_product_details_desktop_module_default()).holder,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (swiper_product_details_desktop_module_default()).tab,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(product_details_tabs_component, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (swiper_product_details_desktop_module_default()).content,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (swiper_product_details_desktop_module_default()).container,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.t, {
          observer: true,
          observeParents: true,
          parallax: true,
          onSwiper: function onSwiper(e) {
            return dispatch({
              type: 'SET_PRODUCT_DETAILS_CONTROLLER',
              payload: {
                productDetailsSwiperController: e
              }
            });
          },
          controller: state.layout.productDetailsSwiperController ? {
            control: state.layout.productDetailsSwiperController
          } : undefined,
          spaceBetween: 100,
          onSlideChange: function onSlideChange(swiper) {
            var index = swiper.activeIndex;
            var tab = product_details_data/* default.find */.ZP.find(function (p) {
              return p.id === product_details_data/* allSlides */.eW[index].tabId;
            });

            if (tab) {
              handleSwiperChange(tab);
              setReference(tab);
            }

            rerender(function (r) {
              return !r;
            });
          },
          onTouchStart: function onTouchStart(_, event) {
            var clientX = utils_getClientXFromDifferentEvents(event);
            setTouchLocation(clientX);
          },
          onTouchEnd: function onTouchEnd(_, event) {
            var _ref4, _parentSlug, _ref5, _productDetails$find;

            var clientX = utils_getClientXFromDifferentEvents(event);
            DataLayer/* default.swipeEvent */.Z.swipeEvent({
              element: (touchLocation !== null && touchLocation !== void 0 ? touchLocation : 0) > clientX ? 'proximo' : 'anterior',
              elementCategory: 'imagem',
              pageSection: pageSection,
              pageSubsection: (_ref4 = (_parentSlug = (_ref5 = (touchLocation !== null && touchLocation !== void 0 ? touchLocation : 0) > clientX ? nextSlide : previousSlide) === null || _ref5 === void 0 ? void 0 : _ref5.parentSlug) !== null && _parentSlug !== void 0 ? _parentSlug : (_productDetails$find = product_details_data/* default.find */.ZP.find(function (c) {
                return c.id === state.layout.selectedDetailTab;
              })) === null || _productDetails$find === void 0 ? void 0 : _productDetails$find.slug) !== null && _ref4 !== void 0 ? _ref4 : ''
            });
          },
          children: product_details_data/* default.map */.ZP.map(function (tab) {
            return tab.children.map(function (slide) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Slide, {
                  tab: tab,
                  slide: swiper_product_details_desktop_component_objectSpread(swiper_product_details_desktop_component_objectSpread({}, slide), {}, {
                    tabId: tab.id
                  }),
                  productDetailsVersion: productDetailsVersion
                })
              }, "detail-".concat(tab.id, "-").concat(slide.id));
            });
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (swiper_product_details_desktop_module_default()).controls,
          children: [state.layout.pageX >= 1200 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (swiper_product_details_desktop_module_default()).bullets,
            children: product_details_data/* allSlides.filter */.eW.filter(function (t) {
              var _state$layout$current;

              return t.tabId === ((_state$layout$current = state.layout.currentTab) === null || _state$layout$current === void 0 ? void 0 : _state$layout$current.id);
            }).map(function (c, index) {
              var _state$layout$product;

              return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                title: c.title,
                className: (0,scssStyles/* default */.Z)([(swiper_product_details_desktop_module_default()).bullet, ((_state$layout$product = state.layout.productDetailsSwiperController) === null || _state$layout$product === void 0 ? void 0 : _state$layout$product.activeIndex) === c.index ? (swiper_product_details_desktop_module_default()).active : '']),
                onClick: function onClick() {
                  var _c$tabId;

                  DataLayer/* default.clickEvent */.Z.clickEvent({
                    element: c.slug,
                    elementCategory: 'icone',
                    pageSection: 'conteudo',
                    pageSubsection: (_c$tabId = c.tabId) !== null && _c$tabId !== void 0 ? _c$tabId : ''
                  });

                  if (c.index && state.layout.productDetailsSwiperController) {
                    var _state$layout$product2;

                    (_state$layout$product2 = state.layout.productDetailsSwiperController) === null || _state$layout$product2 === void 0 ? void 0 : _state$layout$product2.slideTo(c.index);
                  }
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
              }, "bullet-sw-".concat(c.id));
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (swiper_product_details_desktop_module_default()).arrows,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ArrowButton */.b4, {
              previous: true,
              light: true,
              disabled: ((_state$layout$product3 = (_state$layout$product4 = state.layout.productDetailsSwiperController) === null || _state$layout$product4 === void 0 ? void 0 : _state$layout$product4.activeIndex) !== null && _state$layout$product3 !== void 0 ? _state$layout$product3 : 0) - 1 < 0,
              handleClick: function handleClick() {
                var _state$layout$product5;

                var pageSubsection = state.layout.selectedDetailTab;
                DataLayer/* default.clickEvent */.Z.clickEvent({
                  element: 'anterior',
                  elementCategory: 'icone',
                  pageSection: pageSection,
                  pageSubsection: pageSubsection
                });
                (_state$layout$product5 = state.layout.productDetailsSwiperController) === null || _state$layout$product5 === void 0 ? void 0 : _state$layout$product5.slidePrev();
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ArrowButton */.b4, {
              light: true,
              disabled: ((_state$layout$product6 = (_state$layout$product7 = state.layout.productDetailsSwiperController) === null || _state$layout$product7 === void 0 ? void 0 : _state$layout$product7.activeIndex) !== null && _state$layout$product6 !== void 0 ? _state$layout$product6 : product_details_data/* allSlides.length */.eW.length) >= product_details_data/* allSlides.length */.eW.length - 1,
              handleClick: function handleClick() {
                var _state$layout$product8;

                var pageSubsection = state.layout.selectedDetailTab;
                DataLayer/* default.clickEvent */.Z.clickEvent({
                  element: 'proximo',
                  elementCategory: 'icone',
                  pageSection: pageSection,
                  pageSubsection: pageSubsection
                });
                (_state$layout$product8 = state.layout.productDetailsSwiperController) === null || _state$layout$product8 === void 0 ? void 0 : _state$layout$product8.slideNext();
              }
            }), !!(nextSlide !== null && nextSlide !== void 0 && nextSlide.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (swiper_product_details_desktop_module_default()).nextTab,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Pr\xF3ximo"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: nextSlide === null || nextSlide === void 0 ? void 0 : nextSlide.title
              })]
            })]
          })]
        })]
      })
    })]
  });
});
/* harmony default export */ var swiper_product_details_desktop_component = (SwipersDesktop);
// EXTERNAL MODULE: ./src/assets/index.ts + 1 modules
var assets = __webpack_require__(3059);
// EXTERNAL MODULE: ./src/sections/product-details-section/product-details-swiper-component/swiper-product-details-mobile.module.scss
var swiper_product_details_mobile_module = __webpack_require__(9052);
var swiper_product_details_mobile_module_default = /*#__PURE__*/__webpack_require__.n(swiper_product_details_mobile_module);
;// CONCATENATED MODULE: ./src/sections/product-details-section/product-details-swiper-component/swiper-product-details-mobile.component.tsx


function swiper_product_details_mobile_component_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function swiper_product_details_mobile_component_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? swiper_product_details_mobile_component_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : swiper_product_details_mobile_component_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















swiper_esm/* default.use */.ZP.use([swiper_esm/* A11y */.s5, swiper_esm/* Keyboard */.N1, swiper_esm/* Thumbs */.o3]);
var pageSubsection = 'tudo-sobre-strada';
var swiper_product_details_mobile_component_Slide = (0,es/* observer */.Pi)(function (_ref) {
  var slide = _ref.slide;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (swiper_product_details_mobile_module_default()).slideContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (swiper_product_details_mobile_module_default()).slideImage,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        alt: slide.title,
        title: slide.title,
        src: slide.image.fullPath3x,
        layout: "fill",
        objectFit: "contain",
        objectPosition: "top"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (swiper_product_details_mobile_module_default()).slideDetails,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: slide.title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (swiper_product_details_mobile_module_default()).slideDescription,
        children: [slide.descriptionMobile, !!slide.fileUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (swiper_product_details_mobile_module_default()).ctas,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            href: slide.fileUrl,
            className: (swiper_product_details_mobile_module_default()).buy,
            target: '_blank',
            children: ["Saiba Mais", /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ChevronRight */._Q, {})]
          })
        })]
      })]
    })]
  });
});

var swiper_product_details_mobile_component_Tab = function Tab(_ref2) {
  var _state$layout$product, _state$layout$product2, _state$layout$product3, _state$layout$product4, _state$layout$product10, _state$layout$product11;

  var tab = _ref2.tab,
      rerender = _ref2.rerender,
      setReference = _ref2.setReference;

  var _useState = (0,react.useState)(),
      touchLocation = _useState[0],
      setTouchLocation = _useState[1];

  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var bulletProps = utils_getRangeOfEntries((_state$layout$product = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product === void 0 ? void 0 : _state$layout$product.activeIndex, tab.children);
  var activeIndex = (_state$layout$product2 = (_state$layout$product3 = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product3 === void 0 ? void 0 : _state$layout$product3.activeIndex) !== null && _state$layout$product2 !== void 0 ? _state$layout$product2 : 0;

  var getMaxHeight = function getMaxHeight(id) {
    if (state.layout.selectedDetailTab === id) {
      return 700;
    }

    return 0;
  };

  var handleSelectedDetailTab = function handleSelectedDetailTab(tab) {
    if (tab) {
      dispatch({
        type: 'SET_CURRENTLY_VISIBLE_NAV',
        payload: {
          tab: tab
        }
      });
    }

    dispatch({
      type: 'SET_DETAIL_TAB',
      payload: {
        isMobile: true,
        selectedDetailTab: tab
      }
    });
  };

  var handleSwiper = function handleSwiper(e, tabId) {
    dispatch({
      type: 'SET_PRODUCT_DETAILS_MOBILE_SWIPER_CONTROLLER',
      payload: {
        productDetailsMobileSwiperController: e,
        tabId: tabId
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      className: (0,scssStyles/* default */.Z)(['accordion', 'noFocus', state.layout.selectedDetailTab === tab.id ? 'active' : '', (swiper_product_details_mobile_module_default()).accordionTopic]),
      title: state.layout.selectedDetailTab === tab.id ? 'Fechar' : 'Expandir',
      onClick: function onClick() {
        DataLayer/* default.clickEvent */.Z.clickEvent({
          element: tab.title,
          elementCategory: 'botao',
          pageSection: 'conteudo',
          pageSubsection: pageSubsection
        });
        handleSelectedDetailTab(state.layout.selectedDetailTab === tab.id ? null : tab);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "chevron",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: assets.ui.accordionChevron,
          alt: "Ver mais",
          width: 14,
          height: 8
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: tab.title
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "panel-".concat(tab.id),
      className: (0,scssStyles/* default */.Z)(['panel', (swiper_product_details_mobile_module_default()).topicAnswer]),
      style: {
        maxHeight: getMaxHeight(tab.id)
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        id: "panel-body-".concat(tab.id),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.t, {
          observer: true,
          observeParents: true,
          parallax: true,
          onSwiper: function onSwiper(e) {
            return handleSwiper(e, tab.id);
          },
          controller: state.layout.productDetailsMobileSwiperController[tab.id] != null ? {
            control: state.layout.productDetailsMobileSwiperController[tab.id]
          } : undefined,
          onSlideChange: function onSlideChange(e) {
            var tabSelected = product_details_data/* default.find */.ZP.find(function (p) {
              return p.id === tab.id;
            });
            handleSwiper(e, tab.id);
            setReference(tabSelected);
            rerender(function (r) {
              return !r;
            });
          },
          onTouchStart: function onTouchStart(_, event) {
            var clientX = utils_getClientXFromDifferentEvents(event);
            setTouchLocation(clientX);
          },
          children: tab.children.map(function (slide) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_product_details_mobile_component_Slide, {
                slide: swiper_product_details_mobile_component_objectSpread(swiper_product_details_mobile_component_objectSpread({}, slide), {}, {
                  tabId: tab.id
                })
              })
            }, "".concat(tab.id, "-x-0-").concat(slide.id));
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (swiper_product_details_mobile_module_default()).controls,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* ArrowButton */.b4, {
            previous: true,
            disabled: ((_state$layout$product4 = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product4 === void 0 ? void 0 : _state$layout$product4.activeIndex) === 0,
            className: (swiper_product_details_mobile_module_default()).arrow,
            handleClick: function handleClick() {
              var _state$layout$product5;

              DataLayer/* default.clickEvent */.Z.clickEvent({
                element: 'anterior',
                elementCategory: 'icone',
                pageSection: pageSubsection,
                pageSubsection: tab.slug
              });
              (_state$layout$product5 = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product5 === void 0 ? void 0 : _state$layout$product5.slidePrev();
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (swiper_product_details_mobile_module_default()).bullets,
            children: [!!bulletProps.before && Array.from(Array(bulletProps.before).keys()).slice(0, 2).map(function (_, i) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (0,scssStyles/* default */.Z)([(swiper_product_details_mobile_module_default()).bullet, i == 1 || bulletProps.before === 1 ? 'mediumBullet' : 'smallerBullet']),
                onClick: function onClick() {
                  DataLayer/* default.clickEvent */.Z.clickEvent({
                    element: "foto-".concat(activeIndex - 2),
                    elementCategory: 'icone',
                    pageSection: 'conteudo',
                    pageSubsection: pageSubsection
                  });

                  if (state.layout.productDetailsMobileSwiperController && state.layout.productDetailsMobileSwiperController[tab.id]) {
                    var _state$layout$product6;

                    (_state$layout$product6 = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product6 === void 0 ? void 0 : _state$layout$product6.slideTo(activeIndex - 2);
                  }
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
              }, "smaller-bullet-ProductDetails-before-".concat(i));
            }), tab.children.map(function (c, index) {
              var _state$layout$product7;

              if (bulletProps.range.indexOf(index) === -1) return null;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                title: c.title,
                className: (0,scssStyles/* default */.Z)([(swiper_product_details_mobile_module_default()).bullet, ((_state$layout$product7 = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product7 === void 0 ? void 0 : _state$layout$product7.activeIndex) === index ? (swiper_product_details_mobile_module_default()).active : '']),
                onClick: function onClick() {
                  DataLayer/* default.clickEvent */.Z.clickEvent({
                    element: tab.children[index + 1].slug,
                    elementCategory: 'icone',
                    pageSection: 'tudo-sobre',
                    pageSubsection: tab.slug
                  });

                  if (c.index && state.layout.productDetailsMobileSwiperController && state.layout.productDetailsMobileSwiperController[tab.id]) {
                    var _state$layout$product8;

                    (_state$layout$product8 = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product8 === void 0 ? void 0 : _state$layout$product8.slideTo(index);
                  }
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
              }, "bullet-s-j-".concat(c.id));
            }), !!bulletProps.after && Array.from(Array(bulletProps.after).keys()).slice(0, 2).map(function (_, i) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (0,scssStyles/* default */.Z)([(swiper_product_details_mobile_module_default()).bullet, i == 0 || bulletProps.after === 1 ? 'mediumBullet' : 'smallerBullet']),
                onClick: function onClick() {
                  DataLayer/* default.clickEvent */.Z.clickEvent({
                    element: "foto-".concat(activeIndex + 2),
                    elementCategory: 'icone',
                    pageSection: 'conteudo',
                    pageSubsection: pageSubsection
                  });

                  if (state.layout.productDetailsMobileSwiperController && state.layout.productDetailsMobileSwiperController[tab.id]) {
                    var _state$layout$product9;

                    (_state$layout$product9 = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product9 === void 0 ? void 0 : _state$layout$product9.slideTo(activeIndex + 2);
                  }
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})
              }, "smaller-bullet-ProductDetails-after-".concat(i));
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ArrowButton */.b4, {
            className: (swiper_product_details_mobile_module_default()).arrow,
            disabled: ((_state$layout$product10 = (_state$layout$product11 = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product11 === void 0 ? void 0 : _state$layout$product11.activeIndex) !== null && _state$layout$product10 !== void 0 ? _state$layout$product10 : tab.children.length - 1) >= tab.children.length - 1,
            handleClick: function handleClick() {
              var _state$layout$product12;

              DataLayer/* default.clickEvent */.Z.clickEvent({
                element: 'proximo',
                elementCategory: 'icone',
                pageSection: pageSubsection,
                pageSubsection: tab.slug
              });
              (_state$layout$product12 = state.layout.productDetailsMobileSwiperController[tab.id]) === null || _state$layout$product12 === void 0 ? void 0 : _state$layout$product12.slideNext();
            }
          })]
        })]
      })
    })]
  });
};

var SwipersMobile = function SwipersMobile(_ref3) {
  var setReference = _ref3.setReference;

  var _useState2 = (0,react.useState)(false),
      rerender = _useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (swiper_product_details_mobile_module_default()).container,
    children: product_details_data/* default.map */.ZP.map(function (tab) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_product_details_mobile_component_Tab, {
          tab: tab,
          rerender: rerender,
          setReference: setReference
        })
      }, "sw-frag-".concat(tab.id));
    })
  });
};

/* harmony default export */ var swiper_product_details_mobile_component = (SwipersMobile);
;// CONCATENATED MODULE: ./src/sections/product-details-section/index.tsx










var ProductDetails = function ProductDetails() {
  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var setReference = function setReference(tab) {
    var _state$layout$product, _state$layout$selecte, _state$layout$product2;

    var reference;
    var suffix;
    var index = !state.layout.isDesktop ? (_state$layout$product = state.layout.productDetailsMobileSwiperController[(_state$layout$selecte = state.layout.selectedDetailTab) !== null && _state$layout$selecte !== void 0 ? _state$layout$selecte : 0]) === null || _state$layout$product === void 0 ? void 0 : _state$layout$product.activeIndex : (_state$layout$product2 = state.layout.productDetailsSwiperController) === null || _state$layout$product2 === void 0 ? void 0 : _state$layout$product2.activeIndex;

    if (tab) {
      reference = (0,product_details_data/* getProductDetails */.KL)(product_details_data/* productDetails */.gK).find(function (p) {
        return p.id === "data-".concat(tab === null || tab === void 0 ? void 0 : tab.id);
      });

      if (!state.layout.isDesktop) {
        suffix = tab.children[index !== null && index !== void 0 ? index : 0].slug;
      } else {
        suffix = product_details_data/* allSlides */.eW[index !== null && index !== void 0 ? index : 0].slug;
      }
    } else {
      suffix = product_details_data/* allSlides */.eW[index !== null && index !== void 0 ? index : 0].slug;
      reference = (0,product_details_data/* getProductDetails */.KL)(product_details_data/* productDetails */.gK).find(function (p) {
        var _state$layout$current;

        return p.id === "data-".concat((_state$layout$current = state.layout.currentTab) === null || _state$layout$current === void 0 ? void 0 : _state$layout$current.id);
      });
    }

    if (reference) {
      if (state.layout.selectedDetailTab) {
        dispatch({
          type: "SET_CURRENTLY_VISIBLE_NAV",
          payload: {
            view: reference,
            suffix: suffix
          }
        });
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SectionElement */.pK, {
    id: "ProductDetails",
    navReference: menu_data/* PRODUCT_DETAILS_REF */.qT,
    className: (product_details_section_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (product_details_section_module_default()).title,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
        children: ["Tudo sobre a ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "Fiat Strada"
        })]
      })
    }), state.layout.isDesktop ? /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_product_details_desktop_component, {
      setReference: setReference
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_product_details_mobile_component, {
      setReference: setReference
    })]
  });
};
;// CONCATENATED MODULE: ./src/data/profile.data.tsx

var dataProfile = [{
  imageMobile: assets/* profiles.image1 */.eH.image1,
  imageDesktop: assets/* profiles.image3 */.eH.image3,
  title: "Produtor Rural",
  text: "A Fiat Strada tem a força e a capacidade de carga que todo produtor rural precisa. Confira as condições exclusivas para você que pega pesado no campo.",
  url: "https://www.fiat.com.br/vendas-diretas/produtores-rurais.html/",
  buttonText: "Saiba mais"
}, {
  imageMobile: assets/* profiles.image2 */.eH.image2,
  imageDesktop: assets/* profiles.image4 */.eH.image4,
  title: "Empresas",
  text: "O maior volume de carga da categoria foi feito para quem carrega o negócio sobre rodas. Confira as condições exclusivas para a sua empresa.",
  url: "https://www.fiat.com.br/vendas-diretas/cnpj-e-microempresarios.html/",
  buttonText: "Saiba mais"
}];
// EXTERNAL MODULE: ./src/sections/profile-section/profile-section.module.scss
var profile_section_module = __webpack_require__(6018);
var profile_section_module_default = /*#__PURE__*/__webpack_require__.n(profile_section_module);
;// CONCATENATED MODULE: ./src/sections/profile-section/index.tsx










var ProfileSection = function ProfileSection() {
  var reference = (0,menu_data/* dataMenuLabels */.SC)().find(function (c) {
    return c.slug === "rural-e-empresas";
  });

  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SectionElement */.pK, {
    noPadding: true,
    id: "profileSection",
    className: (profile_section_module_default()).profileSection,
    navReference: reference,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (profile_section_module_default()).title,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
        children: ["Est\xE1 procurando o ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "parceiro perfeito"
        }), " para o trabalho?"]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (profile_section_module_default()).container,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (profile_section_module_default()).gallery,
        children: dataProfile.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (profile_section_module_default()).box,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (profile_section_module_default()).content,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (profile_section_module_default()).textHolder,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: item.title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (profile_section_module_default()).text,
                  children: item.text
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* CTAButton */.m3, {
                  href: item.url,
                  className: (profile_section_module_default()).ctaButton,
                  text: item.buttonText,
                  title: item.buttonText,
                  handleClick: function handleClick() {
                    return DataLayer/* default.clickEvent */.Z.clickEvent({
                      element: item.buttonText,
                      elementCategory: "cta",
                      pageSection: "conteudo",
                      pageSubsection: item.title
                    });
                  }
                })]
              })
            })
          }, item.title);
        })
      })
    })]
  });
};

/* harmony default export */ var profile_section = (ProfileSection);
// EXTERNAL MODULE: ./src/sections/stories-section/stories-section.module.scss
var stories_section_module = __webpack_require__(5653);
var stories_section_module_default = /*#__PURE__*/__webpack_require__.n(stories_section_module);
;// CONCATENATED MODULE: ./src/sections/stories-section/index.tsx









var MainStories = (0,es/* observer */.Pi)(function () {
  var items = [];
  items.push({
    showNext: true,
    title: storiesFirstTitleTag,
    body: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (stories_section_module_default()).slides,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (stories_section_module_default()).slidesContainer,
        title: storiesFirstTitleTag,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/images/ui/selo-mais-vendido.svg",
          width: 200,
          height: 120,
          alt: "Selo Mais Vendido"
        })
      })
    }),
    scrollCtaOrientation: "vertical",
    background: {
      src: storiesFirstBackground,
      alt: storiesFirstAltTag
    },
    durationInS: 15
  });
  dataHero.map(function (item) {
    return items.push({
      showNext: true,
      title: item.titleStories,
      subtitle: item.title,
      description: item.descriptionStories,
      body: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (stories_section_module_default()).slides,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (stories_section_module_default()).slidesContainer,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (stories_section_module_default()).bottomBox,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                children: item.titleStories
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (stories_section_module_default()).contentText,
                children: item.descriptionStories
              })]
            })
          })
        })
      }),
      scrollCtaOrientation: "vertical",
      background: {
        src: item.backgrounds[1],
        alt: item.altTag
      },
      durationInS: 15
    });
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SectionElement */.pK, {
    id: "mobileStories",
    navReference: (0,menu_data/* dataMenuLabels */.SC)()[0],
    className: (stories_section_module_default()).container,
    noPadding: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Stories */.fQ, {
      items: items
    })
  });
});
/* harmony default export */ var stories_section = (MainStories);
// EXTERNAL MODULE: ./src/sections/versions-section/v3/version/index.tsx + 1 modules
var version = __webpack_require__(1828);
// EXTERNAL MODULE: ./src/sections/versions-section/v3/version/version.module.scss
var version_module = __webpack_require__(2326);
var version_module_default = /*#__PURE__*/__webpack_require__.n(version_module);
;// CONCATENATED MODULE: ./src/sections/versions-section/v3/index.tsx








var v3_reference = (0,menu_data/* dataMenuLabels */.SC)().find(function (c) {
  return c.slug === "versoes";
});
var VersionsSectionV3 = (0,es/* observer */.Pi)(function () {
  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SectionElement */.pK, {
    noPadding: true,
    id: "versions",
    navReference: v3_reference,
    className: (version_module_default()).main,
    onVisibilityChange: function onVisibilityChange(load) {
      var index = version/* cars.findIndex */.NU.findIndex(function (c) {
        return c.slug === state.layout.currentVersion.slug;
      });

      if (load) {
        var _cars;

        var suffix = (_cars = version/* cars */.NU[index !== null && index !== void 0 ? index : 0]) === null || _cars === void 0 ? void 0 : _cars.slug;
        setTimeout(function () {
          if (v3_reference && state.layout.currentTab && suffix) {
            dispatch({
              type: "SET_CURRENTLY_VISIBLE_NAV",
              payload: {
                view: v3_reference,
                suffix: suffix
              }
            });
          }
        }, 100);
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(version/* default */.ZP, {})
  });
});
;// CONCATENATED MODULE: ./src/sections/versions-section/index.ts

;// CONCATENATED MODULE: ./src/sections/index.ts







// EXTERNAL MODULE: ./src/sections/cta-section/cta-section.module.scss
var cta_section_module = __webpack_require__(351);
var cta_section_module_default = /*#__PURE__*/__webpack_require__.n(cta_section_module);
;// CONCATENATED MODULE: ./src/sections/cta-section/index.tsx






var CTASection = function CTASection() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (cta_section_module_default()).ctaSection,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (cta_section_module_default()).title,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
        children: ["Vamos ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "Negociar?"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (cta_section_module_default()).buttonHolder,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Conditional */.hW, {
        notOn: 'desktop',
        children: menu_data/* dataCTASectionMobile */.Lp === null || menu_data/* dataCTASectionMobile */.Lp === void 0 ? void 0 : menu_data/* dataCTASectionMobile.map */.Lp.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* CTAButton */.m3, {
            href: item.url,
            className: (cta_section_module_default()).ctaButton,
            text: item.label,
            title: item.label,
            iconCode: item.iconCode,
            handleClick: function handleClick() {
              return DataLayer/* default.clickEvent */.Z.clickEvent({
                element: item.label,
                elementCategory: "cta",
                pageSection: "footer",
                pageSubsection: "ctas"
              });
            }
          }, "menu-cta-".concat(item.id));
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Conditional */.hW, {
        notOn: 'mobile',
        children: menu_data/* dataCTASection */._C === null || menu_data/* dataCTASection */._C === void 0 ? void 0 : menu_data/* dataCTASection.map */._C.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* CTAButton */.m3, {
            href: item.url,
            className: (cta_section_module_default()).ctaButton,
            text: item.label,
            title: item.label,
            iconCode: item.iconCode,
            handleClick: function handleClick() {
              return DataLayer/* default.clickEvent */.Z.clickEvent({
                element: item.label,
                elementCategory: "cta",
                pageSection: "footer",
                pageSubsection: "ctas"
              });
            }
          }, "menu-cta-".concat(item.id));
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/sections/picape-proud-section/picape-proud.module.scss
var picape_proud_module = __webpack_require__(7426);
var picape_proud_module_default = /*#__PURE__*/__webpack_require__.n(picape_proud_module);
;// CONCATENATED MODULE: ./src/sections/picape-proud-section/index.tsx








var PicapeProudSection = function PicapeProudSection() {
  var reference = (0,menu_data/* dataMenuLabels */.SC)().find(function (c) {
    return c.slug === "off-road";
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (picape_proud_module_default()).container,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SectionElement */.pK, {
      id: "photoSection",
      className: (0,scssStyles/* default */.Z)([(picape_proud_module_default()).box, (picape_proud_module_default()).red]),
      navReference: reference,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (picape_proud_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (picape_proud_module_default()).contentTitle,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
            className: (picape_proud_module_default()).title,
            children: ["Versatilidade para ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Qualquer desafio"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Motor turbo, tecnologia e conforto tanto para o lazer ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " quanto para o trabalho. A picape que enfrenta qualquer ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " desafio. Veja as ofertas e garanta a sua."]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          target: "_blank",
          href: menu_data/* links.picapes */.Ok.picapes,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (picape_proud_module_default()).universal_cta,
            children: "Aproveitar Ofertas"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var picape_proud_section = (PicapeProudSection);
// EXTERNAL MODULE: ./src/sections/banner-more-sold/banner-more-sold.module.scss
var banner_more_sold_module = __webpack_require__(5113);
var banner_more_sold_module_default = /*#__PURE__*/__webpack_require__.n(banner_more_sold_module);
;// CONCATENATED MODULE: ./src/assets/banner-more-sold-asset.ts

var BANNER_MORE_SOLD_PREFIX = "".concat(imagePrefixes/* PREFIX */.Bq, "banner-more-sold/");
var BANNER_MORE_SOLD_ASSETS = {
  mobile: {
    background: "".concat(BANNER_MORE_SOLD_PREFIX, "background/background-mobile.webp"),
    cars: "".concat(BANNER_MORE_SOLD_PREFIX, "cars/cars-mobile.webp")
  },
  desktop: {
    background: "".concat(BANNER_MORE_SOLD_PREFIX, "background/background-desktop.webp"),
    cars: "".concat(BANNER_MORE_SOLD_PREFIX, "cars/cars-desktop.webp")
  }
};
/* harmony default export */ var banner_more_sold_asset = (BANNER_MORE_SOLD_ASSETS);
;// CONCATENATED MODULE: ./src/sections/banner-more-sold/index.tsx









var banner_more_sold_reference = (0,menu_data/* dataMenuLabels */.SC)().find(function (c) {
  return c.slug === "mais-vendido";
});

var BannerMoreSold = function BannerMoreSold() {
  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* SectionElement */.pK, {
    id: "BannerMaisVendido",
    navReference: banner_more_sold_reference,
    className: (0,scssStyles/* default */.Z)([(banner_more_sold_module_default()).sectionContainer]),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (banner_more_sold_module_default()).lettering,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
        className: (banner_more_sold_module_default()).title,
        children: ["O carro mais", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "vendido do Brasil"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: (banner_more_sold_module_default()).description,
        children: ["Pelo 4\xBA ano consecutivo, a Fiat Strada conquista o pa\xEDs", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "inteiro. L\xEDder absoluta de vendas, a picape est\xE1 pronta", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "para qualquer desafio. Garanta j\xE1 a sua!"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* CTAButton */.m3, {
        className: (banner_more_sold_module_default()).ctaButton,
        href: menu_data/* links.banner_mais_vendido */.Ok.banner_mais_vendido,
        text: "Compre a sua",
        title: "Compre a sua"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: state.layout.isDesktop ? banner_more_sold_asset.desktop.cars : banner_more_sold_asset.mobile.cars,
      alt: "Carros",
      className: (banner_more_sold_module_default()).cars
    })]
  });
};

/* harmony default export */ var banner_more_sold = (BannerMoreSold);
;// CONCATENATED MODULE: ./pages/index.tsx


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


















var Home = function Home(_ref) {
  var navRef = _ref.navRef,
      slugSuffix = _ref.slugSuffix;

  var _useContext = (0,react.useContext)(context/* Context */._),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var timeout = (0,react.useRef)();

  var _useState = (0,react.useState)(false),
      loadedSlugSuffix = _useState[0],
      setLoadedSlugSuffix = _useState[1];

  (0,react.useEffect)(function () {
    if (navRef && state.layout.requestFinished) {
      timeout.current = setTimeout(function () {
        var _navRef$reference;

        dispatch({
          type: 'SCROLL_TO_REFERENCE',
          payload: {
            reference: (_navRef$reference = navRef.reference) !== null && _navRef$reference !== void 0 ? _navRef$reference : navRef
          }
        });
      }, 400);
    }

    return function () {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, [dispatch, navRef, slugSuffix, state.layout.requestFinished]);

  var deleteCaches = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var keys;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return window.caches.keys();

            case 3:
              keys = _context.sent;
              _context.next = 6;
              return Promise.all(keys.map(function (key) {
                return caches["delete"](key);
              }));

            case 6:
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function deleteCaches() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleResize = function handleResize() {
    var _window, _window2;

    dispatch({
      type: 'SET_PAGE',
      payload: {
        pageX: (_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth
      }
    });
    dispatch({
      type: 'SET_IS_DESKTOP',
      payload: {
        isDesktop: ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.innerWidth) > 1024
      }
    });

    if (state.layout.isDesktop && state.layout.menuOpen) {
      dispatch({
        type: 'SET_MENU_OPEN',
        payload: {
          menuOpen: false
        }
      });
    }
  };

  (0,react.useEffect)(function () {
    var _window3;

    (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  (0,react.useEffect)(function () {
    try {
      if ('serviceWorker' in navigator) {
        caches.keys().then(function (cacheNames) {
          cacheNames.forEach(function (cacheName) {
            caches["delete"](cacheName);
          });
        });
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          var _iterator = _createForOfIteratorHelper(registrations),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var registration = _step.value;
              registration.unregister();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        })["catch"](function (err) {
          console.log('Service Worker registration failed: ', err);
        });
      }

      if (!localStorage.getItem('cacheReset')) {
        deleteCaches() // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then(function (_) {
          localStorage.setItem('cacheReset', 'yes');
        });
      }
    } catch (error) {
      console.log('error cache', error);
    }
  }, []);
  (0,react.useEffect)(function () {
    var _window4, _window4$location;

    if (state && (_window4 = window) !== null && _window4 !== void 0 && (_window4$location = _window4.location) !== null && _window4$location !== void 0 && _window4$location.search) {
      var queryObject = window.location.search;

      if (queryObject) {
        dispatch({
          type: 'SET_QUERY_STRING',
          payload: {
            queryString: new URLSearchParams(queryObject).toString()
          }
        });
      }
    }
  }, []);
  (0,react.useEffect)(function () {
    if (slugSuffix && !loadedSlugSuffix) {
      var _Object$keys;

      var tabSlide = product_details_data/* allSlides.find */.eW.find(function (tab) {
        return tab.slug === slugSuffix;
      });

      if ((_Object$keys = Object.keys(state.layout.slugSuffixes)) !== null && _Object$keys !== void 0 && _Object$keys.length && navRef !== null && navRef !== void 0 && navRef.slug) {
        dispatch({
          type: 'SET_STOP_HISTORY_CHANGE',
          payload: {
            stopHistoryChange: true
          }
        });
        setTimeout(function () {
          var tabReference = product_details_data/* default.find */.ZP.find(function (p) {
            return p.id === navRef.slug;
          });

          if (tabReference) {
            dispatch({
              type: 'SET_CURRENTLY_VISIBLE_NAV',
              payload: {
                tab: tabReference
              }
            });
            dispatch({
              type: 'SWIPE_TO_TAB',
              payload: {
                indexInfo: true,
                tab: tabSlide
              }
            });

            if (!state.layout.isDesktop) {
              dispatch({
                type: 'SET_DETAIL_TAB',
                payload: {
                  isMobile: true,
                  selectedDetailTab: tabReference
                }
              });
            }
          }

          setLoadedSlugSuffix(true);
        }, 500);

        if (state.layout.slugSuffixes[navRef === null || navRef === void 0 ? void 0 : navRef.slug]) {
          setTimeout(function () {
            state.layout.slugSuffixes[navRef === null || navRef === void 0 ? void 0 : navRef.slug](slugSuffix);
            dispatch({
              type: 'SET_STOP_HISTORY_CHANGE',
              payload: {
                stopHistoryChange: false
              }
            });
            setLoadedSlugSuffix(true);
          }, 0);
        } else {
          dispatch({
            type: 'SET_STOP_HISTORY_CHANGE',
            payload: {
              stopHistoryChange: false
            }
          });
        }
      }

      if (slugSuffix) {
        var versionSelected = version/* cars.find */.NU.find(function (version) {
          return version.slug === slugSuffix;
        });

        if (versionSelected) {
          dispatch({
            type: 'SET_CURRENT_VERSION',
            payload: {
              currentVersion: versionSelected
            }
          });
        }
      }
    }
  }, [navRef, state.layout.slugSuffixes, slugSuffix, loadedSlugSuffix, dispatch, state.layout.isDesktop]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components/* ContainerBody */.Bb, {
      children: [state.layout.isDesktop ? /*#__PURE__*/(0,jsx_runtime.jsx)(HeroDesktop, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(stories_section, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(banner_more_sold, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(picape_proud_section, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(VersionsSectionV3, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(profile_section, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(GalleryV1, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductDetails, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CTASection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(footer_section, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* WhatsappBtn */.wk, {})]
    })
  });
};

/* harmony default export */ var pages = (Home);

/***/ }),

/***/ 5113:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"banner-more-sold_sectionContainer__JTOj4","lettering":"banner-more-sold_lettering__Tfvgd","title":"banner-more-sold_title__2quak","description":"banner-more-sold_description__3aPXO","ctaButton":"banner-more-sold_ctaButton__WxFeG","cars":"banner-more-sold_cars__LRYdT","margin":"banner-more-sold_margin__utbFl","pointer":"banner-more-sold_pointer__DgIB7","loading":"banner-more-sold_loading__u0cAe","loadIn":"banner-more-sold_loadIn__zZrWx"};

/***/ }),

/***/ 351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaSection":"cta-section_ctaSection__D5kiZ","title":"cta-section_title__M7B_1","ctaButton":"cta-section_ctaButton__aL8DU","buttonHolder":"cta-section_buttonHolder__0ei0E"};

/***/ }),

/***/ 4450:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__Z_KD3","social":"footer_social__9XPQK","disclaimer":"footer_disclaimer__66GhW","legalText":"footer_legalText__A92gI"};

/***/ }),

/***/ 1007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"gallery-section_container__dYo_T","title":"gallery-section_title__VNRjF","expandedGallery":"gallery-section_expandedGallery__tGzvy","closeButton":"gallery-section_closeButton__ZD_bz","controls":"gallery-section_controls__5gphz","swiperMobile":"gallery-section_swiperMobile__Xi5Xc","controlsDesktop":"gallery-section_controlsDesktop__u2mFm","arrowRight":"gallery-section_arrowRight__U1C9t","arrowLeft":"gallery-section_arrowLeft__9kCJy","expandIcon":"gallery-section_expandIcon__ivgw_","videoHolder":"gallery-section_videoHolder__YSGvH","bullet":"gallery-section_bullet__ntLpw","active":"gallery-section_active__AlKvz","mainImage":"gallery-section_mainImage__5IZCG","aligner":"gallery-section_aligner__8piRv","thumbsDesktop":"gallery-section_thumbsDesktop__1RxCW","thumbs":"gallery-section_thumbs__nVwy_","bar":"gallery-section_bar__17egw","expandedSlide":"gallery-section_expandedSlide__nOSPU","galleryContainer":"gallery-section_galleryContainer__fbNKj","margin":"gallery-section_margin__u_tiz","pointer":"gallery-section_pointer__n_hKk","loading":"gallery-section_loading__p1ka5","loadIn":"gallery-section_loadIn__mYyep"};

/***/ }),

/***/ 6146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainSlide":"HeroDesktop_mainSlide__OBL2O","svg1":"HeroDesktop_svg1__XKwqt","svg2":"HeroDesktop_svg2__5rNzu","pageHeading":"HeroDesktop_pageHeading__4KKWZ","container":"HeroDesktop_container__mnpQ3","scrollImage":"HeroDesktop_scrollImage__atH7V","slides":"HeroDesktop_slides__A87uA","fullBgGradient":"HeroDesktop_fullBgGradient__vM8b7","centered":"HeroDesktop_centered__d6SUd","content":"HeroDesktop_content__C1hpc","wrapLogo":"HeroDesktop_wrapLogo__eTls6","boxLogo":"HeroDesktop_boxLogo__RlH5d","descriptionContent":"HeroDesktop_descriptionContent__ZfxBH","descriptionLayoutTwo":"HeroDesktop_descriptionLayoutTwo__DxsWg","line":"HeroDesktop_line__ZMoW5","tltBottom":"HeroDesktop_tltBottom___A5k0","logoContent":"HeroDesktop_logoContent__M0z2I","logoHero":"HeroDesktop_logoHero__KfJbc"};

/***/ }),

/***/ 7426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"picape-proud_container__4qypC","photoContent":"picape-proud_photoContent__PwGGt","box":"picape-proud_box__C_etm","red":"picape-proud_red__nxJnT","content":"picape-proud_content__uDTXB","title":"picape-proud_title___oh5e","contentTitle":"picape-proud_contentTitle__wpPjr","contentArea":"picape-proud_contentArea__b692_","numberAndDescription":"picape-proud_numberAndDescription__wKkGi","titleText":"picape-proud_titleText__tcBTd","universal_cta":"picape-proud_universal_cta__SrgIE"};

/***/ }),

/***/ 3559:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"product-details-section_container__sNJY3","title":"product-details-section_title__kvsRN"};

/***/ }),

/***/ 603:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"holder":"swiper-product-details-desktop_holder__1RgX5","container":"swiper-product-details-desktop_container__d8wAo","nextTab":"swiper-product-details-desktop_nextTab__Umxiy","videoWrapper":"swiper-product-details-desktop_videoWrapper__57RoK","slideContainer":"swiper-product-details-desktop_slideContainer__SyLY0","controls":"swiper-product-details-desktop_controls__TbVLQ","arrows":"swiper-product-details-desktop_arrows__7vWjW","bullets":"swiper-product-details-desktop_bullets__xDgQQ","bullet":"swiper-product-details-desktop_bullet__1XIkX","active":"swiper-product-details-desktop_active__HXMYZ","slideImageContainer":"swiper-product-details-desktop_slideImageContainer__jfzSD","slideDetails":"swiper-product-details-desktop_slideDetails__Wwwgd","slideDescription":"swiper-product-details-desktop_slideDescription__jSsRR"};

/***/ }),

/***/ 9052:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"swiper-product-details-mobile_container__r1_2B","topicAnswer":"swiper-product-details-mobile_topicAnswer__UIORo","nextTab":"swiper-product-details-mobile_nextTab__7tmHw","controls":"swiper-product-details-mobile_controls__n5VPv","bullet":"swiper-product-details-mobile_bullet__mNAzo","active":"swiper-product-details-mobile_active__qGTNe","videoWrapper":"swiper-product-details-mobile_videoWrapper__ce2oX","accordionTopic":"swiper-product-details-mobile_accordionTopic__Mnw_0","slideContainer":"swiper-product-details-mobile_slideContainer__5urKe","slideImage":"swiper-product-details-mobile_slideImage__U1RVJ","slideDetails":"swiper-product-details-mobile_slideDetails__ggk5U","slideDescription":"swiper-product-details-mobile_slideDescription__wRDNi","ctas":"swiper-product-details-mobile_ctas___CZ9p","buy":"swiper-product-details-mobile_buy__rdbXn"};

/***/ }),

/***/ 297:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"product-details-tabs_container__24rUs","tab":"product-details-tabs_tab__rgJpa","content":"product-details-tabs_content__50JJh","active":"product-details-tabs_active__1Rx_4"};

/***/ }),

/***/ 6018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileSection":"profile-section_profileSection__5TXwW","title":"profile-section_title__3G7U_","gallery":"profile-section_gallery__OIV8_","box":"profile-section_box__nYMLm","content":"profile-section_content__szy_I","textHolder":"profile-section_textHolder__oIe9Z","text":"profile-section_text__qJSd_","container":"profile-section_container__9ydkH","ctaButton":"profile-section_ctaButton__H6FHc"};

/***/ }),

/***/ 5653:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageHeading":"stories-section_pageHeading__3N97h","firstSlide":"stories-section_firstSlide__e_Nxe","slides":"stories-section_slides__PN5TX","content":"stories-section_content__Nc_3G","descriptionContent":"stories-section_descriptionContent__uRYfU","slidesContainer":"stories-section_slidesContainer__u_5dP","topBox":"stories-section_topBox__EJjS6","wrapLogo":"stories-section_wrapLogo__GvyPI","bottomBox":"stories-section_bottomBox__UQbop"};

/***/ })

}]);